  document.addEventListener("DOMContentLoaded", function () {
    const urlParams = new URLSearchParams(window.location.search);
    const successMessage = "✅ Your message has been successfully submitted";

    if (urlParams.has("contact_posted") && urlParams.get("contact_posted") === "true") {
        if (window.location.hash === "#ContactForm-1") {
            showMessage("contact-form-1-message", successMessage);
        } else if (window.location.hash === "#ContactForm-2") {
            showMessage("contact-form-message", successMessage);
        }
    }

    function showMessage(targetId, message) {
        let targetElement = document.getElementById(targetId);
        if (targetElement) {
            targetElement.innerText = message;
            targetElement.style.display = "block";
        }
    }
});

